'use client'

import {
  Box,
  Container,
  Flex,
  Heading,
  Image,
  Icon,
  Stack,
  Text,
} from '@chakra-ui/react'
import {
  FcAssistant,
} from 'react-icons/fc'
import SectionTitleCard from './SectionTitleCard'

// Import local images
import dahliaImage from './speakers/dahlia.jpg'
import loganImage from './speakers/mark.jpeg'
import jaiImage from './speakers/jai.jpg'
import christianImage from './speakers/christian.png'
import malleshImage from './speakers/mallesh.jpg'
import ciamacImage from './speakers/ciamac.jpg'
import rodImage from './speakers/rod.jpg'
import shivImage from './speakers/shiv.jpeg'
import yuImage from './speakers/yufeng.jpg'
import danningImage from './speakers/danning.jpeg'
import devinImage from './speakers/devin.jpeg'
import brandonImage from './speakers/brandon.jpeg'
import claraImage from './speakers/clara.jpg'
import romanImage from './speakers/roman.jpeg'

const Card = ({ heading, description, imageUrl, href }) => {
  return (
    <Box
      maxW={{ base: 'full', md: '250px' }}
      w={'full'}
      borderWidth="1px"
      borderRadius="xl"
      overflow="hidden"
      p={6}
      bg="white"
      boxShadow="md"
      transition="all 0.3s"
      _hover={{
        transform: 'translateY(-5px)',
        boxShadow: 'xl',
      }}
    >
      <Stack align={'center'} spacing={4}>
        <Box
          position="relative"
          width="125px"
          height="125px"
        >
          <Image
            src={imageUrl}
            alt={heading}
            w="125px"
            h="125px"
            rounded={'full'}
            objectFit="cover"
            boxShadow="md"
            border="4px solid"
            borderColor="blue.50"
          />
        </Box>
        <Box textAlign="center">
          <Heading size="md" color="blue.600">{heading}</Heading>
          <Text mt={2} fontSize={'sm'} color="gray.600">
            {description}
          </Text>
        </Box>
      </Stack>
    </Box>
  )
}

export default function Speakers() {
  return (
    <Box id="speakers" p={4}>
      <Container maxW={'7xl'}>
        <Flex justify="center">
          <SectionTitleCard gradient="linear(to-r, white.100, white.100)">
            Speakers
          </SectionTitleCard>
        </Flex>
        <Flex flexWrap="wrap" gridGap={12} justify="center">
          <Card
            heading={'Roman Akhtariev'}
            imageUrl={romanImage} // Use the imported image
            description={'Engineer at Osmosis Labs'}
          />
          <Card
            heading={'Prof. Christian Catalini'}
            imageUrl={christianImage} // Use the imported image
            description={'Co-Founder and CSO at Lightspark'}
            href='https://www.lightspark.com/about-lightspark'
          />
          <Card
            heading={'Brandon Curtis'}
            imageUrl={brandonImage} // Use the imported image
            description={'Director of Research at Eigen Labs'}
          />
          <Card
            heading={'Prof. Yu Feng'}
            imageUrl={yuImage} // Use the imported image
            description={'Computer Science in UCSB, CEO at Nubit'}
            href={'https://cs.ucsb.edu/people/faculty/yu-feng'} // Add the appropriate URL
          />
          <Card
            heading={'Prof. Rod Garratt'}
            imageUrl={rodImage} // Use the imported image
            description={'Economics at UCSB'}
            href={'https://econ.ucsb.edu/people/faculty/rod-garratt'} // Add the appropriate URL
          />
          <Card
            heading={'Shiv Kapoor'}
            imageUrl={shivImage} // Use the imported image
            description={'Engineer at Royco Protocol'}
            href={'https://x.com/ShivaanshKapoor'} // Add the appropriate URL
          />
          <Card
            heading={'Mark Logan'}
            imageUrl={loganImage} // Use the imported image
            description={'Engineer at Mysten Labs'}
            href={'https://www.linkedin.com/in/mark-logan-425556b/'} // Add the appropriate URL
          />
          <Card
            heading={'Prof. Dahlia Malkhi'}
            imageUrl={dahliaImage} // Use the imported image
            icon={<Icon as={FcAssistant} w={10} h={10} />}
            description={'Computer Science at UCSB'}
            href='https://cs.ucsb.edu/people/faculty/dahlia-malkhi'
          />
          <Card
            heading={'Jai Massari'}
            imageUrl={jaiImage} // Use the imported image
            description={'Co-Founder and CLO at Lightspark'}
            href='https://www.lightspark.com/about-lightspark'
          />
          <Card
            heading={'Prof. Ciamac Moallemi'}
            imageUrl={ciamacImage} // Use the imported image
            description={'Columbia Business School'}
            href={'https://moallemi.com/ciamac/'} // Add the appropriate URL
          />
          <Card
            heading={'Prof. Mallesh Pai'}
            imageUrl={malleshImage} // Use the imported image
            description={'Economics at Rice University, Consensys'}
            href={'https://x.com/malleshpai?lang=en'} // Add the appropriate URL
          />
          <Card
            heading={'Danning Sui'}
            imageUrl={danningImage} // Use the imported image
            description={'Data Scientist at Flashbots'}
            href={'https://www.linkedin.com/in/danning-eth-%E2%9A%A1%EF%B8%8F%F0%9F%A4%96-507254103/'} // Add the appropriate URL
          />
          <Card
            heading={'Clara Shikhelman'}
            imageUrl={claraImage} // Use the imported image
            description={'Head of Research at Chaincode'}
          />
          <Card
            heading={'Devin Walsh'}
            imageUrl={devinImage} // Add the appropriate image URL
            description={'Executive Director at Uniswap Foundation'} // Add the appropriate description
            href={'https://x.com/devinwalsh'} // Add the appropriate URL
          />
        </Flex>
      </Container>
    </Box>
  )
}